export default "__VITE_ASSET__eb026696__"